import { ErrorMessage } from "./BaseResponse";
import { PagePermissionType, PagePermissionTypeModel } from "./PageName";
export enum PageMode {
    Create = "Create",
    Update = "Update",
    Delete = "Delete"
}


export default class BaseViewModel {
    
    IsTableLoading: boolean = false;
    IsPageLoading: boolean = false;
    TableLoadingLabel: string = "";
    PageLoadingLabel: string = "";
     
    //toast Mesages
    Messages: ErrorMessage[] = [];

     

    public OnToastEntered = (e: any, reason: any, key: string) => {
        this.Messages = this.Messages.filter(i => i.Message !== key);
    }

    public setFocus<T>(element: React.RefObject<T>) {
        if (element && element.current) {
            (element.current as any).focus();
        }
    }

    OnChildChange?: (data?: any) => void;

    Permission?: PagePermissionTypeModel;
}




